import dayjs from "dayjs";

export default function dateFormat(value) {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(value)) return false;
    const [year, month, day] = value.split('-');
    const date = dayjs(`${year}-${month}-${day}`);
    return date.isValid();
}